<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root","class"]);
const className = __MACROS_toRef(__props, "class");

import { toRef as __MACROS_toRef } from "vue";
import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

defineSlots<{ default(props: { disabled: boolean | undefined; item: string }): unknown }>();
withDefaults(defineProps<{ item: string; class?: string; root?: TooltipRootProps } & TooltipContentProps>(), {  })
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" :item="item" />
    </template>
    <template v-if="!!item" #content>
      <div class="tw-whitespace-pre-line" :class="className">
        {{ item }}
      </div>
    </template>
  </Tooltip>
</template>
